<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 170 170"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="85"
      cy="85"
      r="82"
      stroke="currentColor"
      stroke-width="6"
    />
    <rect
      x="32"
      y="65"
      width="40"
      height="6"
      rx="1"
      fill="currentColor"
    />
    <rect
      x="56"
      y="116"
      width="59"
      height="6"
      rx="1"
      fill="currentColor"
    />
    <rect
      x="98"
      y="65"
      width="40"
      height="6"
      rx="1"
      fill="currentColor"
    />
  </svg>
</template>
